(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luloop-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-luloop-header]').forEach((header) => {
    const toggle = header.querySelector('.luloop-header__toggle');
    const nav = header.querySelector('.luloop-header__nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', () => {
      const open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
    nav.addEventListener('click', () => {
      header.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luloop-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-luloop-home]').forEach((root) => {
    const items = root.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    items.forEach((item) => observer.observe(item));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luloop-product-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-luloop-product]').forEach((root) => {
    const mainImage = root.querySelector('.luloop-gallery__main img');
    root.querySelectorAll('[data-gallery-image]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = button.dataset.galleryImage;
        mainImage.srcset = '';
        mainImage.alt = button.dataset.galleryAlt || '';
      });
    });
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const addButton = root.querySelector('[data-add-button]');
    if (!select || !price || !addButton) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      price.textContent = option.dataset.price || price.textContent;
      const available = option.dataset.available === 'true';
      addButton.disabled = !available;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
